import {slideDown, slideUp, slideFromTo} from "./helpers";

class SiteHeaderMobile {
	constructor() {
		this.el                  = document.querySelector( '.site-header-mobile' )
		this.button              = this.el.querySelector( '.site-header-mobile__burger' )
		this.panes               = this.el.querySelectorAll( '.aside__pane' )
		this.mainMenuParentItems = this.el.querySelectorAll( '.aside__main .menu__item.has-children' )
		this.paneParentItems     = this.el.querySelectorAll( '.menu__item.has-pane' )
		this.backItems           = this.el.querySelectorAll( '.menu__item.is-back' )

		this.button.addEventListener(
			'click',
			() => {
            this.toggle()
			}
		)

		// main menu dropdowns
		this.mainMenuParentItems.forEach(
			parentItem => {
            const menuLink = parentItem.querySelector( ':scope > a.menu__link' );
            const menuList = parentItem.querySelector( ':scope > .menu__list' );
            menuLink.addEventListener(
					'click',
					(e) => {
                    e.preventDefault();
						if (parentItem.classList.toggle( 'is-open' )) {
							slideDown( menuList );
							setTimeout(
                                () => {
								const parentMenu = parentItem.closest( '.menu__list' );
								const lastItem   = parentMenu.lastElementChild;
								if (parentItem === lastItem) {
									  const firstChild = menuList.querySelector( '.menu__item:first-child' );
									if (firstChild) {
										firstChild.scrollIntoView( { behavior: 'smooth' } );
									}
								}
								},
                                301
							);
						} else {
                    slideUp( menuList );
                    }
					}
				);
			}
		);

		this.paneParentItems.forEach(
			paneParentItem => {
            paneParentItem.querySelector( ':scope > a' ).addEventListener(
					'click',
					(e) => {
                    e.preventDefault();
                    let targetPane = false;
                    Array.from( this.panes ).every(
                            pane => {
							if (pane.dataset.pane === paneParentItem.dataset.pane) {
								  targetPane = pane;
								  return false;
							}
							return true;
                            }
                        );
					const activePanes         = document.querySelectorAll( '.aside__pane.is-active' );
					const lastActivePane      = activePanes[activePanes.length - 1];
					const lastActivePaneIndex = lastActivePane ? parseInt( lastActivePane.style.zIndex ) : 1;
					if (targetPane.classList.toggle( 'is-active' )) {
						targetPane.style.zIndex = (lastActivePaneIndex + 1).toString();
					} else {
                    targetPane.style.zIndex = '';
					}
					}
				);
			}
		);

		this.backItems.forEach(
			backItem => {
            backItem.querySelector( ':scope > a' ).addEventListener(
					'click',
					(e) => {
                    e.preventDefault();
                    let targetPane = backItem.closest( '.aside__pane' );
                    if (targetPane.classList.toggle( 'is-active' )) {
                        targetPane.style.zIndex = (parseInt( targetPane.style.zIndex ) + 1).toString();
                    } else {
							const delay             = 300;
							setTimeout(
							() => {
							targetPane.style.zIndex = 2;
							},
							delay
							);
                    }
					}
				);
			}
		);

	}

	toggle() {
		this.el.classList.toggle( 'is-active' )
		this.button.classList.toggle( 'is-open' )
	}
}
class SiteHeaderDesktop {
	constructor() {
		this.el                  = document.querySelector( '.site-header-desktop' )
		this.mainMenuParentItems = this.el.querySelectorAll( '.site-header-desktop__top .menu__item.has-children' )
		this.megamenu            = this.el.querySelector( '.site-header-desktop__megamenu' )
		this.megaMenuInner       = this.el.querySelector( '.megamenu__inner' )
		this.panes               = this.megamenu.querySelectorAll( '.megamenu__pane' )
		this.paneParentItems     = this.el.querySelectorAll( '.menu__item.has-pane' )
		this.paneCounter         = 0
		this.topMenu             = this.el.querySelector( '.site-header-desktop__top .site-header-desktop__menu' )
		this.topMenuLists        = this.el.querySelectorAll( '.site-header-desktop__top .site-header-desktop__menu .menu__item.has-children' )
		this.bottomMenu          = this.el.querySelector( '.site-header-desktop__bottom .site-header-desktop__menu' )

		document.addEventListener(
			'click',
			(e) => {
            const targetElement = e.target;
				if ( ! this.topMenu.contains( targetElement )) {
					const activeLists = Array.from( this.topMenuLists ).filter( list => list.classList.contains( 'is-open' ) );
					activeLists.forEach(
					(list) => {
						list.classList.remove( 'is-open' );
						slideUp( list.querySelector( ':scope > .menu__list' ) )
						}
					);
				}
            if ( ! this.bottomMenu.contains( targetElement ) && ! this.megaMenuInner.contains( targetElement )) {
                this.closeMegaMenu();
            }
			}
		);

		this.mainMenuParentItems.forEach(
			parentItem => {
            parentItem.querySelector( ':scope > a.menu__link' ).addEventListener(
					'click',
					(e) => {
                    e.preventDefault();
                    this.onMainMenuParentItems( parentItem )
					}
				)
			}
		)

		this.paneParentItems.forEach(
			paneParentItem => {
            paneParentItem.querySelector( ':scope > a' ).addEventListener(
					'click',
					(e) => {
                    e.preventDefault();
                    this.onPaneParentItemClick( paneParentItem )
					}
				)
			}
		)
	}

	closeMegaMenu() {
		const activePanes = Array.from( this.panes ).filter( pane => pane.classList.contains( 'is-active' ) );
		this.el.classList.remove( 'is-active' );
		this.megamenu.classList.remove( 'is-active' );
		this.paneParentItems.forEach(
			item => {
            if (item.classList.contains( 'is-open' )) {
                item.classList.remove( 'is-open' );
            }
			}
		);
		slideUp( this.megamenu );
		activePanes.forEach(
			pane => {
            this.closePane( pane );
			}
		);
	}

	onMainMenuParentItems(parentItem) {
		const parentItems = Array.from( this.mainMenuParentItems );

		parentItems.forEach(
			item => {
            if (item !== parentItem && item.classList.contains( 'is-open' )) {
                item.classList.remove( 'is-open' );
                slideUp( item.querySelector( ':scope > .menu__list' ) );
            }
			}
		);

		if (parentItem.classList.toggle( 'is-open' )) {
			slideDown( parentItem.querySelector( ':scope > .menu__list' ) )
		} else {
			slideUp( parentItem.querySelector( ':scope > .menu__list' ) )
		}
	}

	onPaneParentItemClick(paneParentItem) {
		let activePanes  = Array.from( this.panes ).filter( pane => pane.classList.contains( 'is-active' ) )
		const targetPane = Array.from( this.panes ).find( pane => pane.dataset.pane === paneParentItem.dataset.pane )

		if (paneParentItem.classList.contains( 'is-open' ) && this.megaMenuInner.contains( paneParentItem )) {
			paneParentItem.classList.remove( 'is-open' );
			this.closePane( targetPane );
			return;
		}

		if (activePanes.length === 0) {
			//  Open first pane and megamenu
			paneParentItem.classList.add( 'is-open' )
			this.openPane( targetPane )
			this.el.classList.add( 'is-active' )
			this.megamenu.classList.add( 'is-active' )
			slideDown( this.megamenu )
		} else {
			if (targetPane.classList.contains( 'is-active' )) {
				// Close panes
				if (activePanes.length === this.countClosablePanes( targetPane )) {
					// Close all panes and megamenu
					this.el.classList.remove( 'is-active' )
					this.megamenu.classList.remove( 'is-active' )
					paneParentItem.classList.remove( 'is-open' )
					slideUp( this.megamenu )
					this.closePane( targetPane )
				} else {
					// Close only
					const fromHeight = this.megamenu.offsetHeight
					this.closePane( targetPane )
					activePanes      = activePanes.filter( pane => pane !== targetPane )
					slideFromTo( this.megamenu, fromHeight, Math.max( ...activePanes.map( activePane => activePane.querySelector( '.menu__list' ).offsetHeight ) ) )
				}

			} else {
				//  Open panes while megamenu is active
				const siblings           = Array.from( paneParentItem.closest( '.menu__list' ).querySelectorAll( '.menu__item.has-pane' ) ).filter( pane => pane.dataset.pane !== paneParentItem.dataset.pane )
				const siblingsIds        = siblings.map( sibling => sibling.dataset.pane )
				const activeSiblingsPane = activePanes.find( pane => siblingsIds.includes( pane.dataset.pane ) )

				if (activeSiblingsPane !== undefined) {
					// Other sibling pane is open
					const fromHeight = this.megamenu.offsetHeight
					siblings.forEach(
						(sibling) => {
							sibling.classList.remove( 'is-open' )
						}
					)
					this.closePane( activeSiblingsPane )
					activePanes      = activePanes.filter( pane => pane !== activeSiblingsPane )
					slideFromTo( this.megamenu, fromHeight, false, false )

					setTimeout(
						() => {
							const fromHeight = this.megamenu.offsetHeight
							paneParentItem.classList.add( 'is-open' )
							this.openPane( targetPane )
							activePanes.push( targetPane )
							slideFromTo( this.megamenu, fromHeight, Math.max( ...activePanes.map( activePane => activePane.querySelector( '.menu__list' ).offsetHeight ) ) )
						},
						300
					)
				} else {
					// No other sibling is open
					const fromHeight = this.megamenu.offsetHeight
					paneParentItem.classList.add( 'is-open' )
					this.openPane( targetPane )
					activePanes.push( targetPane )
					slideFromTo( this.megamenu, fromHeight, Math.max( ...activePanes.map( activePane => activePane.querySelector( '.menu__list' ).offsetHeight ) ) )
				}
			}
		}
	}

	openPane(pane) {
		pane.classList.add( 'is-active' )
		this.paneCounter++;
		pane.classList.add( 'is-order-' + this.paneCounter )
		setTimeout(
			() => {
				pane.classList.add( 'is-visible' )
			},
			10
		)
	}

	countClosablePanes(pane) {
		let count = 0;

		if (pane.classList.contains( 'is-active' )) {
			count++;
		}

		Array.from( pane.querySelectorAll( '.menu__item.has-pane' ) ).forEach(
			child => {
				count += this.countClosablePanes( Array.from( this.panes ).find( paneItem => paneItem.dataset.pane === child.dataset.pane ) )
			}
		)

		return count;
	}

	closePane(pane) {
		pane.classList.remove( 'is-visible' )
		setTimeout(
			() => {
				pane.classList.remove( 'is-active' )
				this.paneCounter--;
				for (let i = 1; i < 4; i++) {
					pane.classList.remove( 'is-order-' + i )
				}
				Array.from( pane.querySelectorAll( '.menu__item.has-pane' ) ).forEach( pane => pane.classList.remove( 'is-open' ) )
			},
			300
		)

		Array.from( pane.querySelectorAll( '.menu__item.has-pane.is-open' ) ).forEach(
			child => {
				this.closePane( Array.from( this.panes ).find( paneItem => paneItem.dataset.pane === child.dataset.pane ) )
			}
		)
	}
}

export default class SiteHeader {
	constructor() {
		new SiteHeaderMobile();
		new SiteHeaderDesktop();
	}
}
